exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rp-layers[data-v-88fbc6d2]{overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-88fbc6d2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["node_modules/sass-flex-mixin/_flex.scss","node_modules/bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss","node_modules/bootstrap-sass/assets/stylesheets/bootstrap/mixins/*.scss","src/stylesheets/resources.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project/Main.vue
// module id = 411
// module chunks = 0